import Vue from 'vue';
import VueI18n from 'vue-i18n';
import '@/plugins/axios';
import '@/assets/scss/tailwindcss.scss';
import '@/plugins/fontawesome';
import '@fortawesome/fontawesome-svg-core/styles.css';

Vue.prototype.$wpApplyFlowData = window.wpApplyFlowData;

// TODO Deprecated. Will be removed soon.
// import '@/plugins/bootstrap-vue';
// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@/plugins/vue-mq';

// import Cookie from 'js-cookie';
import '@/plugins/i18n';
import messages from '@/locale';

import '@/mixins/generalMixins';

// const afLocal = Cookie.get('wp-wpml_current_language')?.split('-')[0];
const i18n = new VueI18n({
    locale: window.afConfig?.base_locale || window.afConfig?.locale || 'en', // set locale ge: en | zh | ch | fr | de | es | pt | it 
    messages,
});
export default class InitVueApp {
    constructor(app, el, options = {}) {
        this.app = app;
        this.el = el;
        this.options = options;
        this.init();
    }

    init() {
        new Vue({
            ...this.options,
            render: h => h(this.app),
            i18n,
        }).$mount(`#${this.el}`);

        window.eventBus = new Vue();
    }
}
